module.exports = __webpack_public_path__ + "img/app-icon.e5bca812.png";